
export interface PageContext {
  route?: string;
  url?: string;
  title?: string;
  content: string;
  capturedAt?: number;
}

export interface TeacherChatMessageConfig {
  message: string;
  fromUser: boolean;
  loading: boolean;
  generating: boolean;
  isHtml: boolean;
  tool?: string;
  tool_details?: any;
}

export interface TeacherSuggestion {
  message: string;
  loading?: boolean;
  timeout?: number;
}

export enum TeacherAction {
  REDIRECT = 'redirect',
  PAUSE = 'pause',
  RESTART = 'restart',
  PLAY = 'play',
  VALIDATE = 'validate',
  CHANGE_TEMPO = 'change_tempo',
  INCREASE_VOLUME = 'increase_volume',
  DECREASE_VOLUME = 'decrease_volume',
  TOGGLE_VOLUME = 'toggle_volume',
  SHOW_PLAYER_PARAMETER = 'show_player_parameter',
  TOGGLE_LISTEN_MODE = 'toggle_listen_mode',
  SHOW_PAGE_BUTTON = 'show_page_button'
}

export interface ActionPayload {
  action: TeacherAction;
  parameter?: string | any;
  message?: string;
}
